import ApiClient from "../../../apiClient";
import { BASE_URL, ROLES } from "../../../constant/apiEndPoint";
import CustomToast from "../../../utils/CustomToast";
import * as TYPE from "../ActionConstants";
import { checkSession } from "../auth/AuthActions";

export const loadingToggleAction = (dispatch, status) => {
  return dispatch({
    type: TYPE.IS_FETCHING,
    payload: status,
  });
};

export const getRolesAction = (payload, navigate) => {
  return (dispatch) => {
    loadingToggleAction(dispatch, true);
    ApiClient.get(`${BASE_URL}${ROLES.GET_ROLE_PERMISSIONS}`, payload, true)
      .then((response) => {
        loadingToggleAction(dispatch, false);
        dispatch({
          type: TYPE.GET_ALL_ROLES_SUCCESS,
          payload: response.data.result,
        });
      })
      .catch((error) => {
        loadingToggleAction(dispatch, false);
        if (error.status === 419) {
          CustomToast({
            type: "error",
            message: "Session expired, please login again",
            options: { autoClose: 5000, position: "top-center" },
          });
          checkSession(dispatch, navigate);
          return;
        }
        dispatch({ type: TYPE.GET_ALL_ROLES_FAIL, payload: [] });
        CustomToast({
          type: "error",
          message: "Internal Server Error! Please try again later",
          options: { autoClose: 5000, position: "top-center" },
        });
      });
  };
};
